const loginUser = token => {
    if (token.includes('Bearer ')) {
        token = token.replace('Bearer ', '')
    }
    localStorage.setItem('adm_token', token)
}

const checkLogin = () => {
    return (
        localStorage.getItem('adm_token') !== null &&
        localStorage.getItem('adm_token') !== '' &&
        localStorage.getItem('adm_token') !== undefined
    )
}

const getToken = () => {
    return localStorage.getItem('adm_token')
}

const logoutUser = () => {
    localStorage.removeItem('Nocookie')
    // Clear Storage
    localStorage.clear()
    sessionStorage.clear()
}

export { checkLogin, getToken, loginUser, logoutUser }
